module.exports = __webpack_public_path__ + "static/media/office.c207e1ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/resources/images/office.jpg
// module id = 238
// module chunks = 0